export class ClientNoteModel {
    note_sequence: number;
    client_no: number;
    note_type: number;
    note_text: string;
    note_date: string;

    constructor(
        note_sequence: number,
        client_no: number,
        note_type: number,
        note_text: string,
        note_date: string
    ) {
        this.note_sequence = note_sequence;
        this.client_no = client_no;
        this.note_type = note_type;
        this.note_text = note_text;
        this.note_date = note_date;
    }
}

export class ClientNoteTypeModel {
    note_type: number;
    type_desc: string;

    constructor(
        note_type: number,
        type_desc: string
    ) {
        this.note_type = note_type;
        this.type_desc = type_desc;
    }
}